import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ProductEcosystem() {
  const products = [{
    name: 'CJI Core',
    desc: 'Foundational cognitive and reasoning assessment.'
  }, {
    name: 'NCJI Youth',
    desc: 'Developmental tracking for early education.'
  }, {
    name: 'NCJI Pathways',
    desc: 'Workforce readiness and opportunity alignment.'
  }, {
    name: 'NCJI Civic',
    desc: 'Community resilience and manipulation resistance.'
  }, {
    name: 'NCJI Service',
    desc: 'Integrity and systems reasoning for public sector.'
  }, {
    name: 'NCJI Executive',
    desc: 'Crisis reasoning and governance stability.'
  }, {
    name: 'NCJI Atlas',
    desc: 'Macro-level capability mapping for institutions.'
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-333">
      <div className="mb-12" data-id="element-334">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-335">
          Product Stack
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-336">
          The SyNeural ecosystem
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-337">
        {products.map((product, index) => <motion.div key={product.name} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.05
      }} className="bg-surface-card p-6 rounded-lg border border-line shadow-sm hover:border-navy/30 hover:shadow-md transition-all flex flex-col h-full group cursor-pointer" data-id="element-338">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-339">
              {product.name}
            </h3>
            <p className="text-sm text-ink-muted mb-6 flex-grow" data-id="element-340">
              {product.desc}
            </p>
            <div className="flex items-center text-sm font-medium text-teal group-hover:text-navy transition-colors mt-auto" data-id="element-341">
              Learn More{' '}
              <ArrowRight size={14} className="ml-1 transform group-hover:translate-x-1 transition-transform" data-id="element-342" />
            </div>
          </motion.div>)}
      </div>
    </section>;
}